import { render, staticRenderFns } from "./contractCard.vue?vue&type=template&id=0b1db2a3&"
import script from "./contractCard.vue?vue&type=script&lang=js&"
export * from "./contractCard.vue?vue&type=script&lang=js&"
import style0 from "./contractCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports